import { CHAT_ROOMS_AVATAR_DIAGRAM_DATA_KEY } from '@y42/collaboration/chat';
import { ChangedEvent } from 'gojs';

export const isChatRoomsAvatarEvent = ({ change, propertyName }: ChangedEvent): boolean =>
  change === ChangedEvent.Property && propertyName === CHAT_ROOMS_AVATAR_DIAGRAM_DATA_KEY;
